(() => {
  const SELECTOR = '[data-wijha-reveal], [data-wijha-stagger]';
  const VISIBLE_CLASS = 'is-visible';

  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  let observer;

  function getElements(scope = document) {
    return scope.querySelectorAll(SELECTOR);
  }

  function showAll(elements) {
    elements.forEach((element) => {
      element.classList.add(VISIBLE_CLASS);
    });
  }

  function createObserver() {
    return new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(VISIBLE_CLASS);
          } else {
            entry.target.classList.remove(VISIBLE_CLASS);
          }
        });
      },
      {
        root: null,

        /*
          0px means we use the real viewport.
          As soon as the element leaves the viewport,
          it resets and can animate again when returning.
        */
        rootMargin: '0px',

        /*
          Very small threshold so even large Hero elements
          reliably trigger when entering/leaving.
        */
        threshold: 0.01
      }
    );
  }

  function initAnimations(scope = document) {
    const elements = getElements(scope);

    if (!elements.length) return;

    if (
      prefersReducedMotion ||
      !('IntersectionObserver' in window)
    ) {
      showAll(elements);
      return;
    }

    if (!observer) {
      observer = createObserver();
    }

    elements.forEach((element) => {
      observer.observe(element);
    });
  }

  function resetAnimations() {
    if (prefersReducedMotion) return;

    getElements(document).forEach((element) => {
      element.classList.remove(VISIBLE_CLASS);
    });

    requestAnimationFrame(() => {
      initAnimations(document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initAnimations(document),
      { once: true }
    );
  } else {
    initAnimations(document);
  }

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      resetAnimations();
    }
  });

  document.addEventListener('shopify:section:load', (event) => {
    initAnimations(event.target);
  });
})();